import { AssinaturaEtapaPerfil, PerfilAssinatura, Usuario } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';
import { Orgao } from './orgao.model';

export class UsuarioPerfilAssinatura extends BaseResourceModel {

  constructor(
    public id?: number,
    public usuario?: Usuario,
    public perfil_assinatura?: PerfilAssinatura,
  ) {
    super();
  }

  static converteJson(json: any): UsuarioPerfilAssinatura {
    return Object.assign(new UsuarioPerfilAssinatura(), json);
  }
}
